// Shared imprint page for ALL ecosquirrel tools and the landing page.
// Single source of truth: edit here, it is synced into each app's src/pages/ on
// build by scripts/gen-tokens.mjs. Language is derived from the route.
import { Anchor, Container, Text, Title } from '@mantine/core';
import { useLocation } from 'react-router-dom';

const OPERATOR = {
  name: 'Matthias Schaper',
  street: 'Unterstr. 138',
  city: '53859 Niederkassel',
  country: 'Deutschland',
  email: 'info@ecosquirrel.de',
};

export function ImpressumPage() {
  const { pathname } = useLocation();
  const en = pathname === '/en' || pathname.startsWith('/en/');

  return (
    <Container size="sm" py="xl">
      <Title order={1} mb="lg">
        {en ? 'Imprint' : 'Impressum'}
      </Title>

      <Title order={2} mb="xs">
        {en ? 'Information pursuant to § 5 DDG' : 'Angaben gemäß § 5 DDG'}
      </Title>
      <Text mb="md">
        {OPERATOR.name}
        <br />
        {OPERATOR.street}
        <br />
        {OPERATOR.city}
        <br />
        {OPERATOR.country}
      </Text>

      <Title order={2} mb="xs">
        {en ? 'Contact' : 'Kontakt'}
      </Title>
      <Text mb="md">
        {en ? 'Email' : 'E-Mail'}: <Anchor href={`mailto:${OPERATOR.email}`}>{OPERATOR.email}</Anchor>
      </Text>

      <Title order={2} mb="xs">
        {en ? 'Responsible for content (§ 18 (2) MStV)' : 'Verantwortlich für den Inhalt (§ 18 Abs. 2 MStV)'}
      </Title>
      <Text mb="md">
        {OPERATOR.name}, {OPERATOR.street}, {OPERATOR.city}
      </Text>

      <Title order={2} mb="xs">
        {en ? 'Online dispute resolution' : 'EU-Streitschlichtung'}
      </Title>
      <Text>
        {en
          ? 'The European Commission provides a platform for online dispute resolution (ODR): '
          : 'Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: '}
        <Anchor href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer">
          https://ec.europa.eu/consumers/odr/
        </Anchor>
        .{' '}
        {en
          ? 'We are neither obliged nor willing to participate in dispute resolution proceedings before a consumer arbitration board.'
          : 'Wir sind nicht verpflichtet und nicht bereit, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.'}
      </Text>
    </Container>
  );
}
